<template>
    <div>
        <i v-if="shared" class="far fa-check-square"></i>
        <i v-else class="far fa-square"></i>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @returns {boolean}
       */
      shared() {
        return Boolean(this.row.model.shared);
      },
    }
  }
</script>
